import React, { Component } from 'react';
import PropTypes from "prop-types";

class ImageGalleryWrapper extends Component {
    renderImages = () => {
        return this.props.images.map((imageUrl, i) => {
            return(
                <span className="image__block" key={i}>
                    <img src={imageUrl} id={i} alt={`'${this.props.name}' Image #${i + 1}`}/>
                </span>
            );
        });
    };

    render() {
        return(
            <div className="images_row">
                {this.renderImages()}
            </div>
        )
    }
}

ImageGalleryWrapper.propTypes = {
    images: PropTypes.array.isRequired,
};

export default ImageGalleryWrapper;
